module.exports = __webpack_public_path__ + "static/media/icon_ladder.1985d737.svg";